import { Box, Container, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { appImages } from "../../assets";

let renderData = [
  {
    image: appImages.registerOnThePlatform,
    title: "registerPlatform",
  },
  {
    image: appImages.selectServiceProduct,
    title: "selectServiceProduct",
  },
  {
    image: appImages.makePayment,
    title: "makePayment",
  },

  {
    image: appImages.meetNewWorkers,
    title: "newWorkers",
  },

  {
    image: appImages.receivedYourProduct,
    title: "receivedProduct",
  },
];

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 600 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

const HowWorks = () => {
  const renderCards = (params) => {
    return params.map((val, index) => {
      return (
        <Box key={index} sx={{ px: 1, cursor: "pointer" }}>
          <Box
            border={"1px solid #d9d9d9"}
            borderRadius={2}
            overflow={"hidden"}
          >
            <Box height={185}>
              <img
                src={val.image}
                width={"100%"}
                height={"100%"}
                alt={val.title}
                style={{
                  objectFit: "cover",
                }}
              />
            </Box>
            <Stack
              px={0.75}
              py={1}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              spacing={1}
            >
              <Typography variant="body1" noWrap>
                {t(val.title)}
              </Typography>
              {/* <EastIcon /> */}
            </Stack>
          </Box>
        </Box>
      );
    });
  };

  return (
    <Container maxWidth={"lg"} sx={{ py: 4 }}>
      <Stack textAlign={"center"} mb={5}>
        <Typography variant="heading_pr" component={"h1"}>
          {t("howWorks")}
        </Typography>
        <Typography variant="heading_sec" component={"p"}>
          {t("howWorkDesc")}
        </Typography>
      </Stack>

      <Carousel
        responsive={responsive}
        // infinite={true}
        // autoPlaySpeed={3000}
        // arrows={true}
        // renderButtonGroupOutside={true}
      >
        {renderCards(renderData)}
      </Carousel>
    </Container>
  );
};

export default HowWorks;
